import FeedbackVideoTestimonialPage from './FeedbackVideoTestimonialPage'

export default FeedbackVideoTestimonialPage
